<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="8" style="padding:0">
        <img class="logo" src="../../../static/img/logo.png" />
        <img class="nav-bg" src="../../../static/img/nav-bg.jpg" />
      </el-col>
      <el-col :span="16" style="padding:0">
        <el-menu
          :default-active="$route.path"
          class="el-menu-demo"
          mode="horizontal"
          router
          background-color="#244893"
          text-color="#fff"
          active-text-color="#fff"
        >
          <el-menu-item index="/">{{ $t("menu.home") }}</el-menu-item>
          <el-menu-item index="/products">{{
            $t("menu.product")
          }}</el-menu-item>
          <el-menu-item index="/aboutUs">{{ $t("menu.aboutus") }}</el-menu-item>
          <el-menu-item index="/contactUs">{{
            $t("menu.contactus")
          }}</el-menu-item>
          <!-- <el-menu-item index="/login">{{$t('menu.login')}}</el-menu-item> -->
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              {{ $t("select.title") }}

              <img class="down" src="../../../static/img/down.png" />

              <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="item in $t('select.lang')"
                :key="item.key"
                @click.native="handleClick(item.key)"
                >{{ item.name }}</el-dropdown-item
              >
              <!-- <el-dropdown-item v-for="item in lang" :key="item.key" @click.native="handleClick(item.key)">{{item.name}}</el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
    data(){
        return {
          lang:[]
            // lang:[
            //     {
            //      key:'zh-CN',
            //      name:'简体中文'
            //     },
            //     {
            //      key:'zh-TW',
            //      name:'繁体中文'
            //     },
            //     {
            //      key:'en',
            //      name:'英文'
            //     },
            //     {
            //      key:'ja',
            //      name:'日语'
            //     },
            //     {
            //      key:'ko',
            //      name:'韩语'
            //     }
            // ]
        }
    },

    methods:{
        handleClick(val) {
            console.log('选择的语言',val);
            this.$i18n.locale = val;
        }
    },
    created(){
      // this.lang = $t('select.lang');
    }
}
</script>
<style type="text/css">
.nav-bg {
  float: right;
  width: 42px;
  height: 100px;
}
.el-menu-item {
  font-size: 16px;
  font-weight: bold;
}
.triangle-bottomright {
  width: 0;
  height: 0;
  border-bottom: 100px solid red;
  border-left: 100px solid transparent;
}
.logo {
  width: 225px;
  height: 45px;
  margin-top: 23px;
}
.el-menu.el-menu--horizontal {
  border-bottom: 0;
}
.el-menu--horizontal > .el-menu-item {
  padding: 0 20px;
  height: 100px;
  line-height: 100px;
}
.el-dropdown {
  margin-top: 30px;
}
.el-dropdown-link {
  border: 1px solid #fff;
  border-radius: 20px;
  padding: 0 20px;
  color: #fff;
  height: 40px;
  line-height: 40px;
  display: flex;
  align-items: center;
}
.down {
  margin-left: 10px;
  height: 16px;
  width: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Navi/Navi.vue